<template>
  <div id="page-plant-bulk-stage-update-list" class="container vs-con-loading__container">
    <div class="vx-row mt-10 mb-6">
      <div class="vx-col sm:w-1/3 w-full text-right">
        <span>Excluded Serial Number:</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input class="w-full" v-model="form.excluded_serial_number" placeholder="e.g SN2345,SN344657,S446464" />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full text-right">
        <span>Plant Stage*:</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <select-2
          autocomplete
          class="w-full mb-1"
          :value="form.plant_stage"
          @input="(item) => (form.plant_stage = item && item.value)"
          name="Plant Stage"
          placeholder="Select Plant Stage"
          :options="plantStages"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Plant Stage')">{{ errors.first('Plant Stage') }}</span>
      </div>
    </div>
    <hr />
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-4 text-center">
          <vs-button class="mt-2 mr-2" type="relief" @click="save_changes" :disabled="!validateForm || loading"> Update Plants Stage </vs-button>
          <vs-button to="/batches/list" color="danger" type="relief" class="text-left">Cancel</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'PlantBulkStageUpdate',

  components: {
    Select2
  },

  data: () => ({
    form: {
      excluded_serial_number: '',
      plant_stage: ''
    },
    plantStages: [
      { value: 'seedling', label: 'Seedling' },
      { value: 'pre_veg', label: 'Pre-Veg' },
      { value: 'veg', label: 'Veg' },
      { value: 'flower', label: 'Flower' },
      { value: 'drying', label: 'Drying' },
      { value: 'dried', label: 'Dried' },
      { value: 'sold', label: 'Sold' },
      { value: 'destroyed', label: 'Destroyed' },
      { value: 'mother', label: 'Mother' },
      { value: 'male', label: 'Male' }
    ]
  }),
  methods: {
    ...mapActions('batch', ['updateBulkPlantStage']),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }
      try {
        const { message } = await this.updateBulkPlantStage({
          id: this.$route.params.id,
          data: {
            ...this.form,
            excluded_serial_number: this.form.excluded_serial_number ? this.form.excluded_serial_number.split(',') : []
          }
        })
        this.form.excluded_serial_number = ''
        delete this.form.plant_stage
        this.errors.clear()
        this.$emit('on-success')
        this.form.plant_stage = ''
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  computed: {
    ...mapState('batch', ['loading']),
    validateForm() {
      return !this.errors.any()
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#page-plant-bulk-stage-update-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#page-plant-bulk-stage-update-list > .con-vs-loading')
      }
    }
  }
}
</script>